export enum PaginationDefinition {
	PAGE_SIZE = 20,
	DEFAULT_PAGE_NUMBER = 1,
}
